<table *ngIf="list?.length > 0; else empty">
  <thead>
    <tr>
      <th *ngFor="let heading of headings">
        <span *ngIf="heading.label">{{heading.label}}</span>
        <mat-icon [matTooltip]="heading.tooltip"
          *ngIf="heading.icon">{{heading.icon}}</mat-icon>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of list">
      <td>
        <div fxLayout="row"
          fxLayoutGap="15px">
          <ca-avatar fxFlexAlign="center"
            [image]="row.avatarUrl"
            [fullName]="row.name"></ca-avatar>
          <span fxFlexAlign="center">{{ row.name }}</span>
        </div>
      </td>
      <td *ngFor="let score of row.scores"
        class="number">
        {{ score }}
      </td>
    </tr>
  </tbody>
</table>
<ng-template #empty>
  <p>{{ emptyMessage }}</p>
</ng-template>